// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3jNLi","noInteraction":"EventWrapper_noInteraction__2IDOH","pointerPassthrough":"EventWrapper_pointerPassthrough__3bRl2"};